import React from "react";
import { Card, CardBody } from "reactstrap";
import { H4, SkeletonLoader, SvgIcon } from "Core/Components";

const Widgets1 = ({ data, isLoading }) => {
  return (
    <Card className="widget-1">
      <CardBody>
        <div className="widget-content">
          <div className={`widget-round ${data.color}`}>
            <div className="bg-round">
              <SvgIcon className="svg-fill" iconId={`${data.icon}`} />
              <SvgIcon className="half-circle svg-fill" iconId="halfcircle" />
            </div>
          </div>
          <div>
            {isLoading ? (
              <SkeletonLoader
                attrSpinner={{
                  baseColor: "#ebebeb",
                  highlightColor: "#f5f5f5",
                  height: "20px",
                }}
                attrCount={{
                  count: 1,
                }}
              />
            ) : (
              <H4>{data.total}</H4>
            )}
            <span className="f-light">{data.title}</span>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default Widgets1;
